import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { AnimatePresence, motion } from 'framer-motion';
import { isValidElement } from 'react';
import { useTheme } from '../../hooks/useTheme.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { A as AnimateHeightBox } from '../AnimateHeightBox/AnimateHeightBox.js';
import { B as Body } from '../Body/Body.js';
import { cloneElementWithCssProp } from '../../utils/componentHelpers.js';

var _excluded = ["text", "testId", "className", "domRef", "motionProfile"],
  _excluded2 = ["use"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var variants = {
  enter: {
    y: "-0.8em",
    opacity: 0,
    position: "absolute"
  },
  center: {
    y: 0,
    opacity: 1,
    position: "relative"
  },
  exit: {
    y: "0.8em",
    opacity: 0,
    position: "absolute"
  }
};
function RollingText(_ref) {
  var _ref2;
  var text = _ref.text,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "RollingText" : _ref$testId,
    className = _ref.className,
    domRef = _ref.domRef,
    motionProfile = _ref.motionProfile,
    props = _objectWithoutProperties(_ref, _excluded);
  var themeProps = useTheme();
  var base = themeProps.base,
    globalConfig = themeProps.globalConfig;
  var motionProfileToUse = (_ref2 = motionProfile !== null && motionProfile !== void 0 ? motionProfile : globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.motionProfile) !== null && _ref2 !== void 0 ? _ref2 : "gentle";
  var _ref3 = "use" in props ? props : _objectSpread(_objectSpread({}, props), {}, {
      use: undefined
    }),
    use = _ref3.use,
    otherProps = _objectWithoutProperties(_ref3, _excluded2);
  var _ref4 = "size" in props ? props : _objectSpread(_objectSpread({}, props), {}, {
      size: undefined
    }),
    size = _ref4.size;
  var _ref5 = "weight" in props ? props : _objectSpread(_objectSpread({}, props), {}, {
      weight: undefined
    }),
    weight = _ref5.weight;
  var textAsKey = typeof text === "string" ? text : /*#__PURE__*/isValidElement(text) ? text.props.children : text === null || text === void 0 ? void 0 : text.toString();
  return jsx(AnimateHeightBox, _objectSpread(_objectSpread({}, otherProps), {}, {
    motionProfile: motionProfileToUse,
    testId: testId,
    domRef: domRef,
    className: "".concat(className !== null && className !== void 0 ? className : "", " RollingText"),
    children: cloneElementWithCssProp(use || jsx(Body, {
      size: size,
      weight: weight
    }), {
      testId: "".concat(testId, "__text--").concat(text),
      sx: {
        lineHeight: "1",
        d: "flex",
        justifyContent: "center",
        textAlign: "center"
      },
      className: "RollingText__textContainer",
      children: jsx(AnimatePresence, {
        children: text && jsx(motion.span, _objectSpread(_objectSpread({
          style: {
            position: "absolute"
          },
          className: "RollingText__textContainer__animatingSpan",
          "data-testid": "".concat(testId, "__text--").concat(textAsKey, "__animatingSpan")
        }, _objectSpread({}, motionProfileToUse !== "none" ? {
          variants: variants,
          initial: "enter",
          animate: "center",
          exit: "exit",
          transition: {
            duration: base.motion.normal[motionProfileToUse].jsDuration,
            ease: base.motion.normal[motionProfileToUse].jsEase
          }
        } : {})), {}, {
          children: text
        }), textAsKey)
      })
    })
  }));
}
RollingText.displayName = "RollingText";

export { RollingText as R };
//# sourceMappingURL=RollingText.js.map
